<template>
	<div class="user">
		<el-row>
			<el-col :span="19">
				<el-button size="mini" @click.native="adduser" type="success">添加人员</el-button>
			</el-col>
			<el-col :span="5">
				<el-input v-model="searchkey" @keyup.enter.native="refreshgrid(true)" placeholder="可按账号\姓名搜索" size="small" class="input-with-select"></el-input>
			</el-col>
		</el-row>
		<el-row style="height:10px;"></el-row>
		<el-row>
			<el-col :span="24">
				<tableui
					style="width:100%"
					v-loading="loading"
					ref="usertable"
					:tableData="userlist"
					:columns="columns"
					@gridhandle="gridhandle"
					:gridheight="gridheight"
					@gridsort="gridsort"
					@gridscroll="gridscroll"
				></tableui>
			</el-col>
		</el-row>
		<el-row>
			<el-col>共{{ count }}条数据</el-col>
		</el-row>
		<selectuser ref="selectuser" @selectusersure="selectusersure"></selectuser>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
import selectuser from '@/components/user/selectuser.vue';
export default {
	components: {
		tableui,
		selectuser
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			columns: [
				
			],
			userlist: [],
			count: 0,
			pagecount: 0,
			gridheight: (window.innerHeight * 74) / 100+ 'px',
			userkey: '',
			userinfo: {},
			searchkey: '',
			sort: '', //列表排序
			loading: false,
			pagesize: 200,
			pageindex: 0,
			checkedrow: [],
			mode: '设置人员',
			activeName: '设置人员',
			shopname:'',
			isloadscroll:false,
			checkedrow:[]
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/user/user.scss');
		});
		if (this.urlparam!= undefined) {
			if(this.urlparam.shopname!=undefined){
				this.shopname=this.urlparam.shopname;
			}
		}
		this.init();
	},
	methods: {
		init(){
			if(this.columns.length>0)
				this.refreshgrid(true);
			else{
				var that=this;
				this.$apipost.get.GetColumns({ tab: this.activeName, checkfield: 1, parentid: '', mode: this.mode }).then(res => {
					that.columns = res;
					that.refreshgrid(true);
				});
			}
		},
		//滚动加载列表
		gridscroll(e) {
			if (e != undefined) {
				var that = this;
				const scrollDistance = e.event.target.scrollHeight - e.e.scrollTop - e.event.target.offsetHeight;
				if (scrollDistance <= 84) {
					that.refreshgrid(true);
				}
			}
		},
		//刷新列表
		refreshgrid(isrefresh) {
			var that = this;
			var isload = true;
			if (isrefresh) {
				//刷新
				that.pageindex = 0;
			} else {
				//加载下一页
				if (that.pagecount - 1 > that.pageindex) {
					that.pageindex = that.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if (isload) {
				that.loading = true;
				var search = new Object();
				search.searchkey = this.searchkey;
				search.shopname=this.shopname;
				var paraminfo={
					search:search,
					pageindex: this.pageindex, 
					pagesize: this.pagesize, 
					sort:this.sort,
					userid:localStorage.getItem('userid')
				}
				this.$apipost.get.GetSetUserlist({paraminfo:paraminfo}).then(res => {
					that.loading = false;
					if(isload&&!that.isloadscroll){
						that.gridscroll();
					}
					if(isrefresh){
						that.userlist=[];
					}
					if (res.data.length > 0) {
						if (that.pageindex > 0) {
							that.userlist = that.userlist.concat(JSON.parse(JSON.stringify(res.data)));
						} else {
							that.userlist = JSON.parse(JSON.stringify(res.data));
						}
					}
					that.pagecount = res.pagecount;
					that.count = res.count;
				});
			}
		},
		//列表排序
		gridsort(e) {
			//e.column.prop--排序列名
			//e.column.order--ascending/descending --排序方式
			//console.log('排序', e);
			this.sort = ' ' + e.column.prop + ' ' + e.column.order.replace('ending', '');
			this.GetUserList(false, true);
		},
		//列表中的自定义列的操作事件
		gridhandle(e) {
			if (e.event == 'removeuser') {
				this.removeuser(e);
			}
			if (e.event == 'setadmin') {
				this.setadmin(e);
			}
			if (e.event == 'setrank') {
				this.setrank(e);
			}
		},
		//设置用户为管理员
		setadmin(e) {
			console.log('设置管理员', e);
			this.setuserrank(this.userlist[e.index].u_account, this.userlist[e.index][e.field], this.userlist[e.index].u_rank, 1, e);
		},
		//设置管理员的级别
		setrank(e) {
			// if (this.userlist[e.index].isadmin.toString().toLowerCase() == '是') {
				this.setuserrank(this.userlist[e.index].u_account, '是', this.userlist[e.index].u_rank, 1, e);
			// } else {
			// 	this.$tool.message('请先开启管理员', 0);
			// 	this.userlist[e.index][e.field] = e.oldvalue[e.field];
			// }
		},
		//设置等级
		setuserrank(u_account, isadmin, rank, type, e) {
			var that = this;
			if (isadmin == '是') isadmin = 'true';
			else isadmin = 'false';
			this.$apipost.post.SaveUserRank({ u_account: u_account, 
			isadmin: isadmin.toString().toLowerCase(), 
			rank: rank, groupname: this.shopname }).then(res => {
				if (res.state == '1') {
					this.$tool.message('设置成功', 1);
				} else {
					this.$message.error(res.message);
					if (type == 1) {
						that.userlist[e.index][e.field] = false;
					} else {
						that.userlist[e.index][e.field] = e.oldvalue[e.field];
					}
				}
			});
		},
		//添加用户
		adduser() {
			if(this.$refs.selectuser!=undefined)
				this.$refs.selectuser.init();
		},
		//复选框勾选触发
		checkboxchange(e) {
			if (!e.selectedall) {
				this.checkedrow = e.rows; //勾选了的列表
			}else{
				if(this.userlist.length==1)
					this.checkedrow=this.userlist[0];
			}
		},
		//移除用户
		removeuser(e) {
			var searchinfo = '';
			var userid='';
			var search = {
				id: this.userlist[e.index].id
			};
			searchinfo = JSON.stringify(search);
			var paraminfo = {
				search: searchinfo,
				mode:'用户管理',
				tab: '用户管理',
				sort: '',
				userid: localStorage.getItem('userid')
			};
			this.SetUserShopname(paraminfo,0);
		},
		selectusersure(e){
			if(e.paraminfo!=''){
				//更新所选用户的门店
				this.SetUserShopname(e.paraminfo,1);
			}
		},
		//设置/移除用户所属门店  type--0-移除 1-添加
		SetUserShopname(paraminfo,type){
			var that=this;
			paraminfo.shopname=this.shopname;
			paraminfo.type=type;
			//console.log('设置',JSON.stringify(paraminfo));
			//return false;
			this.$apipost.post.UpdateUserShopname({paraminfo:paraminfo}).then(res => {
				if (res.state == '1') {
					this.$tool.message('设置成功', 1);
					that.$refs.selectuser.showuserlist=false;
					that.refreshgrid(true);
				} else {
					this.$tool.message(res.message, 0);
				}
			});
		}
	}
};
</script>
